var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1538 11.3567C13.1538 11.6534 13.0359 11.938 12.8261 12.1478C12.6163 12.3577 12.3317 12.4755 12.0349 12.4755H4.76219C4.46545 12.4755 4.18085 12.3577 3.97102 12.1478C3.76119 11.938 3.64331 11.6534 3.64331 11.3567V1.84618C3.64331 1.54943 3.76119 1.26484 3.97102 1.05501C4.18085 0.845177 4.46545 0.727295 4.76219 0.727295H9.79716L13.1538 4.08394V11.3567Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79724 15.2728H1.96507C1.66833 15.2728 1.38373 15.1549 1.1739 14.9451C0.964073 14.7353 0.846191 14.4507 0.846191 14.1539V4.08398",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.131ffa45dec87980a35519d05a33da13.svg";
export { ForwardRef as ReactComponent };